module.exports = {"open":"Open","notice":"Notices","more":"More","noNotice":"No notices have been posted.","inquiry":"1:1 Inquiry","noInquiry":"No inquiries have been posted.","answered":"Answered","checking":"In Review","event":"Event","version":"Version"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/en/mainboard.json
// module id = EnK2
// module chunks = 2